// extracted by mini-css-extract-plugin
export default {"seeAll":"AddTrademarkToPortfolioModal_seeAll__ZG7VO"};